module.exports = __webpack_public_path__ + "media/images/new/icons/youtube-63158df807d8f4d2522e084da3610cc8.png";